/**
 * Graphql mutation to create event
 * @module src/graphql/submitInventoryRequest
 */
import gql from 'graphql-tag';

/** creating event */

const SUBMIT_INVENTORY_RETURN = gql`
  mutation submitInventoryReturn(
    $orderId: String
    $orderExternalId: String!
    $accountId: String!
    $salesRepId: String!
    $fromSubInventoryCode: String!
    $salesOrganization: String!
    $shipDate: Date
    $trackingId: String
    $returnReason: String
    $returnType: String
    $lineItems: [UpdateReturnLineItems]
    $returnStatus: String
    $isShippingLabelRequired: Boolean
    $expectedCaseVersion: String
    $system: String
    $version: String
  ) {
    submitInventoryReturn(
      orderId: $orderId
      orderExternalId: $orderExternalId
      accountId: $accountId
      salesRepId: $salesRepId
      fromSubInventoryCode: $fromSubInventoryCode
      salesOrganization: $salesOrganization
      shipDate: $shipDate
      trackingId: $trackingId
      returnReason: $returnReason
      returnType: $returnType
      returnStatus: $returnStatus
      isShippingLabelRequired: $isShippingLabelRequired
      lineItems: $lineItems
      expectedCaseVersion: $expectedCaseVersion
      system: $system
      version: $version
    ) {
      message
      externalId
      submissionId
      status
    }
  }
`;

export default SUBMIT_INVENTORY_RETURN;
